module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', _vm._g(_vm._b({
    staticClass: "hydroware-add-button",
    attrs: {
      "type": "primary",
      "value": "add"
    }
  }, 'el-button', _vm.$attrs, false), _vm.$listeners), [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), (!_vm.text) ? _c('span', [_vm._v("Add")]) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('span', [_vm._v(_vm._s(_vm.text))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fc13be2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/hydroware-add-button.vue
// module id = 836
// module chunks = 1